import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RecipientDto} from '../recipient-dto';

@Component({
    selector: 'secure-recipient-overlay',
    templateUrl: './recipient-overlay.component.html',
    styleUrls: ['./recipient-overlay.component.scss']
})
export class RecipientOverlayComponent implements OnInit {

    @Input() show: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() recipient: EventEmitter<RecipientDto> = new EventEmitter<RecipientDto>();
    isVisible: boolean = false;
    emailAddr: string = '';

    constructor() {}

    ngOnInit(): void {
        this.show.subscribe((data: boolean) => this.onShow(data));
    }

    onShow(indicator: boolean): void {
        this.isVisible = indicator;
    }

    submit(): void {
        this.recipient.emit({recipient: this.emailAddr});
        this.isVisible = false;
    }

    cancel(): void {
        this.isVisible = false;
    }
}
